import API from '@api';
import type { FlocktoryLoyaltyStatus } from './pushUserLoyalty';
import {
  pushFlocktoryGuestLoyaltyToDataLayer,
  pushFlocktoryUserLoyaltyToDataLayer
} from './pushUserLoyalty';

const getLoyaltyStatus = (
  statusId: number | null | undefined
): FlocktoryLoyaltyStatus | null => {
  if (statusId === 2) {
    return 'silver';
  }

  if (statusId === 3) {
    return 'gold';
  }

  if (statusId === 1) {
    return 'basic';
  }

  return null;
};

export const syncFlocktoryUserLoyaltyDataLayer = async (
  isUserLoggedIn: boolean
): Promise<void> => {
  if (!isUserLoggedIn) {
    pushFlocktoryGuestLoyaltyToDataLayer();
    return;
  }

  try {
    const res = await API.getPeopleBillAmount();
    const billData = res?.getPeopleBillAmount;
    const loyaltyStatusId = billData?.peopleItem?.status_id ?? null;

    pushFlocktoryUserLoyaltyToDataLayer({
      bonusPoints: billData?.bill ?? 0,
      loyaltyStatusId,
      loyaltyStatus: getLoyaltyStatus(loyaltyStatusId)
    });
  } catch (error) {
    console.log('Flocktory user loyalty dataLayer sync error:', error);
  }
};
